import React from 'react';

interface MarshmallowSkewerProps {
  className?: string;
  title?: string;
}

/**
 * Marshmallow skewer icon. Uses the hand-drawn image at
 * /roary/marsh-1.png; callers control size via className.
 */
export const MarshmallowSkewer: React.FC<MarshmallowSkewerProps> = ({
  className,
  title = 'Marshmallows',
}) => (
  <img
    src="/roary/marsh-1.png"
    alt={title}
    className={`object-contain ${className ?? ''}`.trim()}
  />
);
